require("./bootstrap");

import { createApp, onMounted } from "vue";

import { VueReCaptcha } from "vue-recaptcha-v3";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

import { ZiggyVue } from "ziggy";

import { StoryblokVue, apiPlugin } from "@storyblok/vue";
import { createPinia } from "pinia";

import Vop from "./components/vop.vue"
import Navbar from "./components/Navbar.vue";
import Steps from "./components/Schedule/Steps.vue";
import Program from "./components/Program/Program.vue";
import AmbienceCarousel from "./components/Ambience/Carousel.vue";
import Faqs from "./components/Faq/Faqs.vue";
import HappeningForm from "./components/Happening/Form.vue";
import VotingForm from "./components/Voting/VotingForm.vue";
import RegistrationEshoper from "./components/RegistrationEshoper/RegistrationEshoper.vue";
import Addressing from "./components/Profile/Addressing.vue";
import MoreAboutShopcamp from "./components/MoreAboutShopcamp.vue";
// import PartnersCard from './components/Partners/PartnersCard.vue';
// import MainPartners from './components/Partners/GridTypes/MainPartners.vue';
import SupportPartners from "./components/Partners/GridTypes/SupportPartners.vue";
// import Partners from './components/Partners/GridTypes/Partners.vue';
// import MedialPartners from './components/Partners/GridTypes/MedialPartners.vue';
import Newsletter from "./components/Newsletter/Newsletter.vue";
import VotingBlock from "./components/Profile/VotingBlock.vue";
import UserWorkshopBlock from "./components/Profile/WorkshopBlock.vue";
import SpeakersBlock from "./components/Speakers/Block.vue";
import LoginForm from "./components/Login/Login.vue";
import Notifications from "./components/Notifications/Notifications.vue";
import LogoutForm from "./components/LogoutForm.vue";
import Workshops from "./components/Workshop/Workshops.vue";
import AssignedWorkshops from "./components/Profile/AssignedWorkshops.vue";
import PartnerSimpleshop from "./components/SimpleshopForms/Partner.vue";
import StandardSimpleshop from "./components/SimpleshopForms/Standard.vue";
import AfternoonSimpleshop from "./components/SimpleshopForms/Afternoon.vue";
import RecordingsSimpleshop from "./components/SimpleshopForms/Recordings.vue";
import Partners from "./components/Partners/Index.vue";
import ConferenceDate from "./components/ConferenceDate.vue";
import LecturesCount from "./components/LecturesCount.vue";
import AttendeesCount from "./components/AttendeesCount.vue";
import FooterDate from "./components/FooterDate.vue";
import ForMedia from "./components/ForMedia.vue";
import CalendarDropdown from "./components/CalendarDropdown.vue";
import InfoItem from "./components/Info/Item.vue";
import InfoContent from "./components/Info/ItemContent/Content.vue";
import InfoVideo from "./components/Info/ItemContent/Video.vue";
import InfoBlock from './components/Info/Block.vue'
import OrganizersBlock from "./components/Organizers/Block.vue"
import RegistrationPage from "./components/Registration/Page.vue"


import useStoryBlokData from "./composables/useStoryBlokData";
import { useStoryBlokStore } from "./stores/storyblok";
import { useStoryblokBridge } from "@storyblok/vue";

const app = createApp({
  components: {
    Navbar,
    Steps,
    Program,
    Faqs,
    VotingForm,
    Vop,
    RegistrationEshoper,
    MoreAboutShopcamp,
    VotingBlock,
    RegistrationPage,
    Addressing,
    // PartnersCard,
    // MainPartners,
    // Partners,
    // MedialPartners,
    Partners,
    OrganizersBlock,
    Newsletter,
    HappeningForm,
    SpeakersBlock,
    AmbienceCarousel,
    UserWorkshopBlock,
    LoginForm,
    SupportPartners,
    Notifications,
    LogoutForm,
    Workshops,
    AssignedWorkshops,
    PartnerSimpleshop,
    StandardSimpleshop,
    ConferenceDate,
    LecturesCount,
    AttendeesCount,
    FooterDate,
    ForMedia,
    CalendarDropdown,
    AfternoonSimpleshop,
    RecordingsSimpleshop,
    InfoItem,
    InfoContent,
    InfoBlock,
    InfoVideo
  },

  setup() {
    const { getStoryBlokData } = useStoryBlokData();
    const storyBlokStore = useStoryBlokStore();

    onMounted(() => {
      getStoryBlokData().then(({ data }) => {
        storyBlokStore.setStoryBlokData(data);

        useStoryblokBridge(data.story.id, (data) => {
          storyBlokStore.setStoryBlokData(data);
        });
      });
    });
  },
});

if (process.env.NODE_ENV === "production") {
  Bugsnag.start({
    apiKey: "e1f46ee43a7c55fd86dfad5c377c3cf3",
    plugins: [new BugsnagPluginVue()],
  });

  const bugsnagVue = Bugsnag.getPlugin("vue");
  app.use(bugsnagVue);
}

const pinia = createPinia();

app.use(VueReCaptcha, {
  siteKey: "6LezIBEbAAAAAGkRr19cRuh_QaQoPP1ZWhEVBuCF",
  loaderOptions: {
    autoHideBadge: true,
  },
});

app.use(StoryblokVue, {
  accessToken: "NwUkw8cwpkvlGSQ6qDODuAtt",
  use: [apiPlugin],
});

app.use(ZiggyVue);

app.use(pinia);

app.mount("#app");
